module.exports = __webpack_public_path__ + "img/partner@2x.0fa6454.jpg";